<template>
  <section>
    <v-dialog
      v-model="showModal"
      max-width="800px"
    >
      <v-card
        color="#ECEFF1"
      >
        <br>
        <h2 class="title-style">
          <v-icon class="icon-style">
            mdi-pencil
          </v-icon> Create Module
        </h2>
        <v-card-text>
          <v-form>
            <v-row>
              <v-col
                cols="12"
                md="6"
              >
                <v-select
                  v-model="moduleType"
                  :items="moduleTypes"
                  filled
                  dense
                  label="Module Type*"
                  :rules="[(v) => !!v || 'Please select the module type.']"
                />
              </v-col>
            </v-row>
            <p class="p-style">
              Add Module Settings Only After Reference<v-icon color="#2E7D32">
                mdi-checkbox-marked-circle
              </v-icon>
            </p>
            <v-textarea
              v-model="organizationModuleSettings"
              outlined
              label="Add Settings"
              class="input-field-styling"
              filled
              auto-grow
              background-color="#CFD8DC"
            />
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="red darken-3"
            @click="showModal = false;"
          >
            Cancel
          </v-btn>
          <v-spacer />
          <v-btn
            :disabled="!isFormValid"
            color="#FF3700"
            @click="createOrganizationModuleSettings()"
          >
            Create
          </v-btn>
        </v-card-actions>
      </v-card>
      <centre-spinner
        :loading="loading"
      />
    </v-dialog>
  </section>
</template>
<script>
  import Constants from 'src/constants';
  import spinner from 'src/views/dashboard/component/SpinnerCentre';

  export default {
    name: 'CreateOrganizationModule',
    components: {
      'centre-spinner': spinner,
    },
    data () {
      return {
        showModal: true,
        organizationModuleSettings: '',
        loading: false,
        moduleTypes: ['banner', 'campaign', 'dashboard', 'digiBoard', 'mediaLibrary', 'report', 'swiftCheckIn', 'support', 'userProfile', 'widgets'],
        moduleType: '',
      };
    },
    computed: {
      isFormValid () {
        return this.organizationModuleSettings !== '' && this.moduleType !== '';
      },
    },
    watch: {
      showModal: function (newval, oldval) {
        if (newval === false) {
          this.$emit('closed');
        }
      },
    },
    methods: {
      async createOrganizationModuleSettings () {
        this.loading = true;
        const organizationId = this.$route.params.organizationId;
        const organizationModuleSettings = JSON.parse(this.organizationModuleSettings);
        await this.$store.dispatch('organizations/createOrganizationModule', {
          settings: {
            settings: organizationModuleSettings,
            module_type: this.moduleType,
          },
          organizationId: organizationId,
        })
          .then(response => {
            this.$store.dispatch('alert/onAlert', {
              message: 'Organization Module created successfully.',
              type: Constants.ALERT_TYPE_SUCCESS,
            });
            this.$emit('get-organization-module-details');
            this.loading = false;
            this.showModal = false;
          }).catch(() => {
            this.loading = false;
          });
      },
    },
  };
</script>
<style scoped>
.title-style {
  color: #37474F;
  margin-left: 30px;
}
.icon-style {
  color: #37474F;
  font-size: 45px;
}
::v-deep .input-field-styling .v-label {
  font-weight: bolder;
  color: #37474F;
  font-size: 14px;
}
.p-style {
  font-size: 18px;
  font-family: 'Times New Roman', Times, serif;
  font-weight: bold;
  color: #546E7A;
  text-align: center;
}
</style>
